(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentFreightDialogController',ShipmentFreightDialogController);

    ShipmentFreightDialogController.$inject = ['entity','$uibModalInstance','ShipmentCustomService','FreightPaymentCustomService','FreightPayment','DateUtils','ToastrService'];

    function ShipmentFreightDialogController(entity, $uibModalInstance, ShipmentCustomService, FreightPaymentCustomService, FreightPayment, DateUtils, ToastrService) {

        var vm = this;
        vm.fps = [];
        vm.currencyTypes = ['USD','EUR'];
        vm.updateMessage = null;
        vm.shipment = entity;

        vm.editFreightPayment = editFreightPayment;
        vm.updateFreightPayment = updateFreightPayment;
        vm.saveFreightPayment = saveFreightPayment;
        vm.initFreightPayment = initFreightPayment;
        vm.openCalendar = openCalendar;
        vm.applyCurrencyType = applyCurrencyType;
        vm.generateInvoiceAmountDisplay = generateInvoiceAmountDisplay;
        vm.onTextClick = onTextClick;

        vm.clear = clear;

        fetchExistingFreightPayments();
        initFreightPayment();

        function fetchExistingFreightPayments() {
            FreightPaymentCustomService.returnFreightPaymentsByShipment(vm.shipment.id).then(function(data) {
                vm.fps = data.data;
                getFreightPaymentTotals();
            }, function(error) {
                ToastrService.error("Failed to get Freight Payments for Shipment " + vm.shipment.shipmentNum, "Error");
            });
        }

        function getFreightPaymentTotals() {
            vm.fpTotalUsd = 0;
            vm.fpTotalEur = 0;
            if(vm.fps.length > 0) {
                angular.forEach(vm.fps, function(value, key) {
                    if(value.invoiceCurrency === 'USD') {
                        vm.fpTotalUsd += value.invoiceAmount;
                    } else {
                        vm.fpTotalEur += value.invoiceAmount;
                    }
                });
            }
        }

        function initFreightPayment() {
            console.log("init freight payment");
            vm.freightPayment = {
                id: null,
                createdOn: new Date(),
                createdBy: 'admin',
                modifiedOn: new Date(),
                modifiedBy: 'admin',
                paymentDate: new Date(),
                invoiceAmount: 0,
                invoiceCurrency: 'USD',
                invoiceAmountDisplay: '0 USD',
                shipmentBookingNumber: vm.shipment.shipmentBookingNumber,
                blNumber: vm.shipment.blNumber,
                carrier: '',
                comment: ''
            };
        }

        function editFreightPayment(index) {
            vm.freightPayment = angular.copy(vm.fps[index]);
            if(vm.freightPayment.paymentDate !== null && vm.freightPayment.paymentDate !== undefined) {
                vm.freightPayment.paymentDate = DateUtils.convertLocalDateFromServer(vm.freightPayment.paymentDate);
            }
        }

        function updateFreightPayment() {
            vm.freightPayment.shipment = {
                id: vm.shipment.id
            };
            vm.updateMessage = "update in progress...";
            vm.isSaving = true;
            FreightPayment.update(vm.freightPayment, onSaveSuccess, onSaveError);
        }

        function saveFreightPayment() {
            vm.freightPayment.shipment = {
                id: vm.shipment.id
            };
            FreightPayment.save(vm.freightPayment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.updateMessage = null;
            fetchExistingFreightPayments();
            initFreightPayment();
            ToastrService.success("Saved/Updated Freight Payment", "Success!");
        }

        function onSaveError() {
            ToastrService.error("Something went wrong with the save/update process", "Error");
        }

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        function onTextClick($event) {
            $event.target.select();
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.freightPaymentDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function applyCurrencyType(type) {
            vm.freightPayment.invoiceCurrency = type;
            generateInvoiceAmountDisplay();
        }

        function generateInvoiceAmountDisplay() {
            var invoiceAmountDisplay = "";
            if(vm.freightPayment.invoiceCurrency !== null && vm.freightPayment.invoiceCurrency !== undefined) {
                invoiceAmountDisplay += vm.freightPayment.invoiceCurrency;
            }
            if(vm.freightPayment.invoiceAmount !== null && vm.freightPayment.invoiceAmount !== undefined) {
                invoiceAmountDisplay += " ";
                invoiceAmountDisplay += vm.freightPayment.invoiceAmount;
            }
            vm.freightPayment.invoiceAmountDisplay = invoiceAmountDisplay;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
